(function() {
  if (window.Wishlist) return;

  const GBJ_WISHLIST_STORAGE_KEY = 'gbj_wishlist';

  window.Wishlist = {
    get: () => JSON.parse(localStorage.getItem(GBJ_WISHLIST_STORAGE_KEY)) || [],
    
    set: (wishlist) => {
      localStorage.setItem(GBJ_WISHLIST_STORAGE_KEY, JSON.stringify(wishlist));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
    },
    
    add: (handle) => {
      const wishlist = window.Wishlist.get();
      if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        window.Wishlist.set(wishlist);
      }
    },
    
    remove: (handle) => {
      const wishlist = window.Wishlist.get();
      const updated = wishlist.filter(item => item !== handle);
      window.Wishlist.set(updated);
    },
    
    toggle: (handle) => {
      const wishlist = window.Wishlist.get();
      if (wishlist.includes(handle)) {
        window.Wishlist.remove(handle);
      } else {
        window.Wishlist.add(handle);
      }
    },
    
    updateHeaderCount: () => {
      const count = window.Wishlist.get().length;
      const bubble = document.querySelector('.wishlist-count-bubble');
      if (bubble) {
        const span = bubble.querySelector('span');
        if (span) span.textContent = count;
        if (count > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      }
    },
    
    updateButtons: () => {
      const wishlist = window.Wishlist.get();
      document.querySelectorAll('.wishlist-btn').forEach(btn => {
        const handle = btn.dataset.productHandle;
        const path = btn.querySelector('.wishlist-heart-path');
        
        if (wishlist.includes(handle)) {
          btn.classList.add('is-active');
          // Directly set SVG attributes for card product wishlist
          if (path && btn.closest('.card__content')) {
            path.setAttribute('fill', '#FF3B3B');
            path.setAttribute('stroke', '#FF3B3B');
            path.setAttribute('stroke-width', '0');
          }
        } else {
          btn.classList.remove('is-active');
          // Reset to default for card product wishlist
          if (path && btn.closest('.card__content')) {
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', '#000000');
            path.setAttribute('stroke-width', '1.5');
          }
        }
      });
    }
  };

  const initWishlist = () => {
    window.Wishlist.updateHeaderCount();
    window.Wishlist.updateButtons();
    
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        const path = btn.querySelector('.wishlist-heart-path');
        
        window.Wishlist.toggle(handle);
        
        // Immediately update the button state
        const wishlist = window.Wishlist.get();
        if (wishlist.includes(handle)) {
          btn.classList.add('is-active');
          // Apply red fill for card product wishlist
          if (path && btn.closest('.card__content')) {
            path.setAttribute('fill', '#FF3B3B');
            path.setAttribute('stroke', '#FF3B3B');
            path.setAttribute('stroke-width', '0');
          }
        } else {
          btn.classList.remove('is-active');
          // Reset to default for card product wishlist
          if (path && btn.closest('.card__content')) {
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', '#000000');
            path.setAttribute('stroke-width', '1.5');
          }
        }
        
        window.Wishlist.updateButtons();
        
        // If we're on the wishlist page, remove the product card from the DOM
        const wishlistContainer = document.getElementById('wishlist-grid-container');
        if (wishlistContainer) {
          // Find the card wrapper (direct child of the grid container)
          const item = btn.closest('.card-wrapper');
          if (item) {
            item.remove();
          }
          
          // Check if wishlist is now empty
          const remainingCards = wishlistContainer.querySelectorAll('.card-wrapper');
          if (remainingCards.length === 0) {
            wishlistContainer.classList.add('hidden');
            const emptyMsg = document.getElementById('wishlist-empty');
            if (emptyMsg) {
              emptyMsg.classList.remove('hidden');
            }
          }
        }
      }
    });
    
    document.addEventListener('wishlist:updated', () => {
      window.Wishlist.updateHeaderCount();
    });

    let debounceTimer = null;
    const observer = new MutationObserver((mutations) => {
      const hasNewWishlistBtn = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 && (
            node.classList?.contains('wishlist-btn') ||
            node.querySelector?.('.wishlist-btn')
          )
        )
      );
      
      if (!hasNewWishlistBtn) return;
      
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        window.Wishlist.updateButtons();
      }, 50);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }
})();
